<template>
    <div class="pa-5">
        <div v-for="item in activeClient.contacts" v-if="activeClient.contacts" :key="item.id">
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Name" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.name ? item.name : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Phone" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.phone ? item.phone : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Position" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.position ? item.position : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.email ? item.email : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.comment ? item.comment : "-" }}
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "contacts-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ExportClientStore", ["activeClient"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
